import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { ReactElement } from "react";
import { CSVMetadataValid } from "src/util/csv";

export default function CsvPreview({
  csvMetadata,
}: {
  csvMetadata: CSVMetadataValid;
}): ReactElement {
  return (
    <div>
      <Table>
        <TableHead>
          <TableRow>
            {csvMetadata.columns.map(c => (
              <TableCell key={c}>{c}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {csvMetadata.sampleRows.map((r, i) => (
            <TableRow key={i}>
              {csvMetadata.columns.map(c => (
                <TableCell key={c}>{r[c]}</TableCell>
              ))}
            </TableRow>
          ))}
          {csvMetadata.sampleRows.length < csvMetadata.rows ? (
            <TableRow>
              <TableCell colSpan={csvMetadata.columns.length}>
                ...and {csvMetadata.rows - csvMetadata.sampleRows.length} more
                rows
              </TableCell>
            </TableRow>
          ) : null}
        </TableBody>
      </Table>
    </div>
  );
}
